import { cn } from '@dashboard/ui'

interface Item {
  icon: React.ReactNode
  value: string | number
}

interface IProps {
  items: Item[]
  value: Item['value']
  onSelected: (value: Item['value']) => void
  itemWidth?: number
}

export default function ButtonIconGroup({ value, items, onSelected }: IProps) {
  let width = 30
  let left = 0
  let idx = items.findIndex(it => it.value == value)
  if (idx > -1) {
    left = 2 + width * idx + 2 * idx
  } //gap + item_size + paddings

  return (
    <div className="relative flex items-center gap-0.5 rounded-lg bg-fg-gray-primary p-0.5">
      <div
        className="absolute z-0 size-[30px] rounded-md bg-fg-primary"
        style={{
          left: `${left}px`,
          transition: 'left 0.2s ease-in-out',
        }}
      />
      {items.map((it, index) => {
        return (
          <div
            className={cn(
              'z-[1] box-border flex size-[30px] cursor-pointer items-center justify-center rounded-md p-0.5 text-center hover:bg-fg-primary-hover',
              value == it.value && 'text-fg-brand-primary',
            )}
            key={index}
            onClick={() => onSelected(it.value)}
          >
            {it.icon}
          </div>
        )
      })}
    </div>
  )
}
